// User configurable options for Xero integration
export const XeroOptionTypes = {
  contactWriteSyncEnabled: 'contactWriteSyncEnabled',
  invoiceWriteSyncEnabled: 'invoiceWriteSyncEnabled',
  creditNoteWriteSyncEnabled: 'creditNoteWriteSyncEnabled',

  invoicePaymentReadSyncEnabled: 'invoicePaymentReadSyncEnabled',
  invoicePaymentWriteSyncEnabled: 'invoicePaymentWriteSyncEnabled',
  overpaymentReadSyncEnabled: 'overpaymentReadSyncEnabled',
  overpaymentWriteSyncEnabled: 'overpaymentWriteSyncEnabled',

  contactSyncStartDate: 'contactSyncStartDate',
  invoiceSyncStartDate: 'invoiceSyncStartDate',
  creditNoteSyncStartDate: 'creditNoteSyncStartDate',
  invoicePaymentSyncStartDate: 'invoicePaymentSyncStartDate',
  overpaymentSyncStartDate: 'overpaymentSyncStartDate'
}